const BASE_URL = process.env.REACT_APP_BACKEND_URL || "";
const TOKEN_KEY = "yardops_token";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || null;
}

export function setToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}

export async function api(path, opts = {}) {
  const token = getToken();
  const headers = { ...(opts.headers || {}) };
  if (token) headers["Authorization"] = `Bearer ${token}`;

  let body;
  if (opts.formData) {
    const usp = new URLSearchParams();
    Object.entries(opts.formData).forEach(([k, v]) => usp.append(k, v));
    body = usp.toString();
    headers["Content-Type"] = "application/x-www-form-urlencoded";
  } else if (opts.body !== undefined) {
    body = JSON.stringify(opts.body);
    headers["Content-Type"] = "application/json";
  }

  const res = await fetch(`${BASE_URL}/api${path}`, {
    method: opts.method || (body ? "POST" : "GET"),
    headers,
    body,
  });

  if (opts.raw) return await res.text();

  if (!res.ok) {
    let detail = `Request failed (${res.status})`;
    try {
      const j = await res.json();
      detail = j.detail || detail;
    } catch (e) { console.error(e); }
    const err = new Error(detail);
    err.status = res.status;
    throw err;
  }
  if (res.status === 204) return undefined;
  return await res.json();
}

export const API_BASE = BASE_URL;
